import React from 'react'
import Fuse from 'fuse.js'

// 0 - perfect match
// 1 - would match anything
const DEFAULT_THRESHOLD = 0.2

interface Props<T> {
  data: Array<T>
  searchKeys: string[]
  thresholdBetweenZeroAndOne?: number
}

export const useFuzzySearch = <T>({
  data,
  searchKeys,
  thresholdBetweenZeroAndOne = DEFAULT_THRESHOLD,
}: Props<T>) => {
  const [searchQuery, setSearchQuery] = React.useState('')
  const fuse = React.useMemo(
    () =>
      new Fuse(data, {
        keys: searchKeys,
        threshold: thresholdBetweenZeroAndOne,
      }),
    [data, searchKeys, thresholdBetweenZeroAndOne]
  )
  const result = React.useMemo(() => {
    if (searchQuery) {
      return fuse?.search(searchQuery).map(({ item }) => item) || []
    }
    return data
  }, [fuse, searchQuery, data])
  const handlers: [
    Array<T>,
    string,
    React.Dispatch<React.SetStateAction<string>>
  ] = React.useMemo(() => [result, searchQuery, setSearchQuery], [
    result,
    searchQuery,
    setSearchQuery,
  ])
  return handlers
}
